import PasswordInput from 'component/field/PasswordInput'
import fieldStyle from 'component/field/fieldStyle'
import DialogWindow from 'component/material/DialogWindow'
import GridContainer from 'component/material/GridContainer'
import GridItem from 'component/material/GridItem'
import PrimaryButton from 'component/material/PrimaryButton'
import {mapErrorResponseToForm} from 'helper/functions'
import {required, samePasswordValidation} from 'helper/validations'
import PropTypes from 'prop-types'
import React from 'react'
import {Field, Form} from 'react-final-form'
import {connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import {changePassword} from 'redux/action/authAction'
import {Trans} from '@lingui/macro'
import withStyles from '@material-ui/core/styles/withStyles'

const ChangeMyPasswordDialog = (props) => {
  const {classes, open, onClose, handleCloseMenu, changePassword} = props

  const handleSubmit = (val) => {
    return changePassword({new_password: val.new_password, old_password: val.old_password})
      .then((res) => {
        onClose()
        handleCloseMenu()
      })
      .catch((err) => {
        return mapErrorResponseToForm(err)
      })
  }

  return (
    <DialogWindow
      title={<Trans>Change my password</Trans>}
      open={open}
      onClose={onClose}
      maxWidth={'xs'}
      fullWidth={true}
      dialogActions={
        <GridContainer spacing={2} justifyContent={'flex-end'}>
          <GridItem>
            <PrimaryButton
              onClick={onClose}
              variant={'outlined'}
              size={'small'}
              fullWidth={false}
              text={<Trans>Close</Trans>}
              className={classes.loginButton}
            />
          </GridItem>
          <GridItem>
            <PrimaryButton
              type="submit"
              onClick={() => document.getElementById('change-password-submit-button').click()}
              size={'small'}
              fullWidth={false}
              text={<Trans>Save</Trans>}
              className={classes.loginButton}
            />
          </GridItem>
        </GridContainer>
      }
    >
      <Form onSubmit={handleSubmit} validate={samePasswordValidation}>
        {(formProps) => {
          return (
            <form onSubmit={formProps.handleSubmit}>
              <GridContainer spacing={2} direction={'row'}>
                <GridItem xs={12}>
                  <Field
                    name="old_password"
                    label={<Trans>Old password</Trans>}
                    component={PasswordInput}
                    validate={required}
                    filters={true}
                    loginPage={true}
                    className={classes.loginPageInput}
                  />
                </GridItem>
                <GridItem xs={12}>
                  <Field
                    name="new_password"
                    label={<Trans>New password</Trans>}
                    component={PasswordInput}
                    validate={required}
                    filters={true}
                    loginPage={true}
                    className={classes.loginPageInput}
                  />
                </GridItem>
                <GridItem xs={12}>
                  <Field
                    name="password_confirmation"
                    label={<Trans>Password confirmation</Trans>}
                    component={PasswordInput}
                    validate={required}
                    filters={true}
                    loginPage={true}
                    className={classes.loginPageInput}
                  />
                </GridItem>
                {/* hidden button which is triggered from outside the form / component,
                  therefore it's hidden */}
                <button
                  disabled={formProps.submitting}
                  id={'change-password-submit-button'}
                  type={'submit'}
                  style={{display: 'none'}}
                />
              </GridContainer>
            </form>
          )
        }}
      </Form>
    </DialogWindow>
  )
}

ChangeMyPasswordDialog.propTypes = {
  changePassword: PropTypes.func,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  classes: PropTypes.object,
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      changePassword,
    },
    dispatch
  )
}

export default compose(
  withStyles(fieldStyle),
  connect((store) => {
    return {}
  }, mapDispatchToProps)
)(ChangeMyPasswordDialog)
